export default __webpack_public_path__ + "media/it-support-vector.0da7749a217d338cb695c5086afd46cd.svg";